import { Routes } from '@angular/router';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import { AuthGuard, RoleBasedGuard } from 'remarketing-angular-library';

export const summaryDisclosuresRoutes: Routes = [
  {
    path: 'summary-disclosures',
    loadComponent: () => import('./components/summarydisclosures/summarydisclosures.component').then(c => c.SummarydisclosuresComponent),
    canActivate: [AgreementsGuard, AuthGuard, RoleBasedGuard],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ],
      roles: ['View_Only'],
    }
  },
];
